<template>
  <div class='page-wrap'>
    <div ref="topbar" class="topbar">
      <div>
        <div class="bread">
          <div class="bread-l">
            <span>待办事宜</span>
            <div class="tabs-wrap">
              <div :class="{ 'active': curTab === 0 }">
                <el-badge :value="todoCount === 0 ? '' : todoCount" :max="999">
                  <div class="tab" @click="changeTab(0)">我的待办</div>
                </el-badge>
              </div>
              <div :class="{ 'active': curTab === 1 }">
                <div class="tab" @click="changeTab(1)">我的已办</div>
              </div>
              <div :class="{ 'active': curTab === 2 }">
                <el-badge :value="launchCount === 0 ? '' : launchCount" :max="999">
                  <div class="tab" @click="changeTab(2)">我的发起</div>
                </el-badge>
              </div>
              <div :class="{ 'active': curTab === 3 }" v-if="!IS_IN_YTS_PUB">
                <el-badge :value="noticeCount === 0 ? '' : noticeCount" :max="999">
                  <div class="tab" @click="changeTab(3)">我的通知</div>
                </el-badge>
              </div>
            </div>
          </div>
          <!-- 搜索框 -->
          <div class="search-wrap">
            <el-input
                size="medium"
                placeholder="搜索关键字"
                v-model="form.keyword"
                clearable
                @clear="changeTerm('search')"
                @keyup.enter.native="changeTerm('search')"
            >
              <i slot="suffix" class="el-icon-search" @click="changeTerm('search')"></i>
            </el-input>
          </div>
        </div>
      </div>

      <!-- 状态选择 -->
      <div class="radio-wrap">
        <section>
          <!-- 代办   -->
          <!-- 2019-08-15删除 curTab === 1 -->
          <section v-show="curTab === 3" class="filter-item">
            <label>状态：</label>
            <el-radio-group :disabled="isLoading" v-model="isRead" @change="changeTerm">
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="0">未读</el-radio>
              <el-radio :label="1">已读</el-radio>
            </el-radio-group>
          </section>

          <!-- 已办 -->
          <section v-show="curTab === 1" class="filter-item">
            <label>时间：</label>
            <el-radio-group :disabled="isLoading" v-model="datePicker" @change="changeTime" class="boldFather">
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="3">最近3天</el-radio>
              <el-radio :label="7">最近7天</el-radio>
              <el-radio :label="30">最近30天</el-radio>
              <el-radio :label="-2">其他</el-radio>
              <el-date-picker
                  v-show="datePicker === -2"
                  class="daterange-wrap"
                  :disabled="isLoading || datePicker !== -2"
                  v-model="dateVals"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy/MM/dd"
                  @change="changeTerm"
                  :default-value="pickerDefault"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-radio-group>
          </section>

          <!-- 发起 -->
          <section v-show="curTab === 2" class="filter-item">
            <label>状态：</label>
            <el-radio-group :disabled="isLoading" v-model="status" @change="changeTerm">
              <el-radio :label="-1">全部</el-radio>
              <el-radio
                  :label="0"
              >未完成{{ launchCount === 0 ? '' : ('(' + (launchCount > 999 ? '999+' : launchCount) + ')') }}
              </el-radio>
              <el-radio :label="1">已完成</el-radio>
              <!-- <el-radio :label="4">已终止</el-radio> -->
            </el-radio-group>
          </section>
          <!-- 待办、发起、通知 时间筛选 -->
          <section
              class="filter-item"
              :class="{'mTop': curTab !== 0}"
              v-show="curTab === 0 || curTab === 2 || curTab === 3"
          >
            <label>时间：</label>
            <el-radio-group :disabled="isLoading" v-model="datePicker" @change="changedohalfTime" class="boldFather">
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="1">当天</el-radio>
              <el-radio :label="2">2-3天</el-radio>
              <el-radio :label="3">3天以上</el-radio>
              <el-radio :label="-2">其他</el-radio>
              <el-date-picker
                  v-show="datePicker === -2"
                  class="daterange-wrap"
                  :disabled="isLoading || datePicker !== -2"
                  v-model="dateVals"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy/MM/dd"
                  @change="changeTerm"
                  :default-value="pickerDefault"
                  :picker-options="pickerOptions"
              ></el-date-picker>
            </el-radio-group>
          </section>
        </section>
        
        <!-- <section class="filter-item">
          <label for>类型：</label>
          <el-radio-group :disabled="isLoading" v-model="form.tag" @change="changeTerm" class="boldFather">
            <el-radio label>全部</el-radio>
            <template v-if="tags.length">
              <el-radio v-for="(tag, index) in tags" :key="index" :label="tag.tagValue">
                <span>{{ tag.name }}</span>
                <span v-if="curTab == 0">({{ tag.count }})</span>
              </el-radio>
            </template>
            <el-radio v-else :disabled="true">其他(略)</el-radio>
          </el-radio-group>
        </section> -->

        <section class="filter-item" v-if="curTab === 0 ">
          <label for>排序：</label>
          <el-radio v-model="order" label="1" class="boldTime">催办排序</el-radio>
          <el-radio v-model="order" label="2" class="boldTime">时间正序</el-radio>
          <el-radio v-model="order" label="0" class="boldTime">时间倒序</el-radio>
        </section>
        <section class="flexBox" :class="IS_IN_YTS_PUB?'wait-stay-tips':''" v-if="curTab === 0">
          <div class="flexAlign">停留时长</div>
          <div class="flexAlign">
            <div class="blockColor"></div>
            >1天
          </div>
          <div class="flexAlign">
            <div class="blockColorY"></div>
            >2天
            <!-- 2次提醒 -->
          </div>
          <div class="flexAlign">
            <div class="blockColorR"></div>
            >3天
            <!-- 3次提醒 -->
          </div>
        </section>
        <section class="flexBox" v-if=" curTab === 2">
          <div class="flexAlign">停留时长</div>
          <div class="flexAlign">
            <div class="blockColor"></div>
            >3天
          </div>
          <div class="flexAlign">
            <div class="blockColorY"></div>
            >5天
            <!-- 2次提醒 -->
          </div>
          <div class="flexAlign">
            <div class="blockColorR"></div>
            >7天
            <!-- 3次提醒 -->
          </div>
        </section>
      </div>
    </div>

    <section class="dohalf-container">
      <div
          v-loading="isLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(250, 250, 250, 1)"
      >
        <v-task-list
            :status="status"
            :type="curTab"
            :data="listData"
            :height="tableHeight"
            :keyword="form.keyword"
            :markedIds="markedIds"
            :markedSystemNo="markedSystemNo"
            :markedBusinessType="markedBusinessType"
            @delData="delData"
            @reload="reload"
            @markIds="markIds"
            @zhugeParmas="zhugeParmas"
            @cuibanFilter="cuibanFilter"
            @defaultFilter="defaultFilter"
            @orderTimeFilter="orderTimeFilter"
        ></v-task-list>

        <el-pagination
            background
            class="ac"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listLen"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="form.pageSize"
            :current-page="form.pageNo"
            @current-change="changePage"
            @size-change="changePageSize"
        ></el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import VTaskList from '@/components/VTaskList'
import {
  cuibaiFilter,
  defaultFilter,
  orderTimeFilter,
  getTodoList,
  getTodoListLHFK,
  getInitiatorList,
  // getSystemList,
  delDohalfData,
  getUserInfo,
  getInitiaorCount,
  getNoticeCount,
  getTags,
  getInitiatorTags
} from '@/api/index'

export default {
  components: { VTaskList },
  data() {
    return {
      order: '1',
      statusOnce: false,
      curTab: 0, // 当前tab { 0:'待办', 1:'已办', 2:'发起'，3:'通知' }
      // ---------------请求参数---------------
      form: {
        isPc: 1,
        keyword: '', // 搜索框值(not required)
        // systemNo: '', // 系统编号(not required)
        tag: '', // 关键字(not required)
        pageNo: 1, // 当前页
        pageSize: 10 // 每页条数
      },
      todoParams: {
        todoType: 0, // 待办类型 { 0:待办, 1:通知, 2:传阅, 3:催办, 4:归档 }
        todoStatus: 0 // 待办状态 { 0:待审批, 1:已审批, 2:已取消 3:已删除, 4:提交中, 5:审批失败 }
      },
      status: -1, // 发起-完成状态 { -1:'全部', 0:'未完成', 1:'已完成' }
      isRead: -1, // 待办/通知-已读状态 { -1:'全部', 0:'未读', 1:'已读' }
      datePicker: -1, // 待办/已办/通知-时间范围快捷选项{ 非负整数: '天数', -1: '全部' }
      dateVals: [], // 我已办的-时间范围 ['开始时间', '结束时间']
      pickerOptions: {
        disabledDate: function (curDate) {
          return new Date().getTime() < curDate.getTime()
        }
      },
      pickerDefault: '',
      // ---------------其他值---------------
      todoCount: 0, // 我代办的-总数
      noticeCount: 0, // 我的通知-总数
      tags: [], // 关键字分类
      sys1: [], // 已办, 系统分类
      sys2: [], // 发起, 系统分类
      // ---------------列表---------------
      isLoading: false, // 加载状态
      listData: [], // 占坑
      listLen: 0, // 总数
      tableHeight: 0, // 表高
      launchCount: 0, // 发起中待办的数量
      markedIds: [], // 标记已读，已办中的id组
      markedSystemNo: [],
      markedBusinessType: [],
      //-----------全局环境变量--------
      IS_IN_YTS_PUB: false, //是否在云图梭的环境中
    }
  },
  watch: {
    order(val) {
      if (val == '0') {
        this.defaultFilter()
      } else if (val == '1') {
        this.cuibanFilter()
      } else {
        this.orderTimeFilter()
      }
    },
    // tab栏切换
    curTab(val) {
      this.form.keyword = ''
      this.form.systemNo = ''
      this.form.tag = ''
      this.form.pageNo = 1
      this.listData = []
      this.listLen = 0
      this.datePicker = -1
      this.dateVals = []
      if (val === 0 || val === 3) {
        this.todoParams.todoType = val === 3 ? 1 : 0
        this.todoParams.todoStatus = 0
        this.isRead = -1
        this.tags = []
      } else if (val === 1) {
        this.todoParams.todoType = 0
        this.todoParams.todoStatus = 1
      } else if (val === 2) {
        this.todoParams.todoType = 0
        this.status = -1
        if (this.statusOnce) {
          this.curTab = 2
          this.status = 0
          this.statusOnce = false
        }
      }
      window.localStorage.setItem('curTab', val)
      this.getData(true)
    }
  },
  methods: {
    // 催办排序
    cuibanFilter() {
      window.zhuge.track('催办排序')
      cuibaiFilter().then(res => {
        if (res.code === 0) {
          this.listData = []
          this.getData(false, false)
        }
      })
    },
    // 默认排序
    defaultFilter() {
      window.zhuge.track('默认排序')
      defaultFilter().then(res => {
        if (res.code === 0) {
          this.listData = []
          this.getData(false, false)
        }
      })
    },
    // 默认排序
    orderTimeFilter() {
      window.zhuge.track('默认排序')
      orderTimeFilter().then(res => {
        if (res.code === 0) {
          this.listData = []
          this.getData(false, false)
        }
      })
    },
    changeTab(n) {
      if (this.isLoading) return false
      this.curTab = n
      // let tab = ['待办', '已办', '发起', '通知'][n]
      window.zhuge.track('切换页签', { tab: n })
    },
    // 返回前台刷新
    listenVisibility() {
      document.addEventListener('visibilitychange', () => {
        this.curTab = parseInt(localStorage.getItem('curTab'))
        let hidden = document.hidden || document.webkitHidden
        !hidden && this.getData(true, false)
      })
    },
    // 请求获取数据
    getData(isInput, isReflash = true) {
      this.isLoading = true
      isReflash && isInput && (this.form.tag = '')
      if (this.curTab === 0) {
        if (this.statusOnce) {
          return
        }
        // 待办
        getTodoList({
          ...this.form,
          ...this.todoParams,
          isRead: this.isRead || '',
          startDate: (this.dateVals && this.dateVals[0]) || '',
          endDate: (this.dateVals && this.dateVals[1]) || ''
        })
          .then(res => {
            this.todoCount = res.data.totalResults
            localStorage.setItem('todoCount', this.todoCount)
            if (isInput && isReflash) {
              this.tags = res.data.tags || []
            }
            this.cb(res)
          })
          .catch(() => {
            this.isLoading = false
          })
      } else if (this.curTab === 1) {
        // 已办
        if (this.statusOnce) {
          return
        }
        let params = {
          ...this.form,
          ...this.todoParams,
          startDate: (this.dateVals && this.dateVals[0]) || '',
          endDate: (this.dateVals && this.dateVals[1]) || '',
          todoType: 0
        }
        getTodoList(params)
          .then(res => {
            this.cb(res)
          })
          .catch(() => {
            this.isLoading = false
          })
        isReflash && isInput && this.getFilterTags(params) // 获取、更新筛选关键字
      } else if (this.curTab === 2) {
        // 发起
        let params = {
          ...this.form,
          status: this.status,
          startDate: (this.dateVals && this.dateVals[0]) || '',
          endDate: (this.dateVals && this.dateVals[1]) || ''
        }
        // if(window.location.href.indexOf('unfinished=1')>-1){
        //     params = {
        //     ...this.form,
        //     status: this.statusOnce,
        //     startDate: (this.dateVals && this.dateVals[0]) || '',
        //     endDate: (this.dateVals && this.dateVals[1]) || ''
        //   }
        // }
        getInitiatorList(params)
          .then(res => {
            this.cb(res)
          })
          .catch(() => {
            this.isLoading = false
          })
        isReflash && isInput && this.getFilterTags(params) // 获取、更新筛选关键字
      } else if (this.curTab === 3) {
        // 通知
        let params = {
          ...this.form,
          ...this.todoParams,
          isRead: this.isRead || '',
          startDate: (this.dateVals && this.dateVals[0]) || '',
          endDate: (this.dateVals && this.dateVals[1]) || '',
          todoType: 1
        }
        getTodoList(params)
          .then(res => {
            this.cb(res)
          })
          .catch(() => {
            this.isLoading = false
          })
        isReflash && isInput && this.getFilterTags(params) // 获取、更新筛选关键字
      }
    },
    // 页面响应
    cb(res) {
      if (this.curTab === 2) {
        this.isLoading = false
        // let LHFKlist = []
        // res.data.list.forEach(item=>{
        //   if(item.appvUser&&item.appvUser[0]&&item.appvUser[0].appvUserName=="Administrator"&&item.systemNo=="LHFK"){
        //     let obj = {F_DJBH:item.flowId}
        //     LHFKlist.push(obj)
        //   }
        // })

        // getTodoListLHFK({
        //   "DATA": LHFKlist
        // })
        //   .then(resdata => {

        //     res.data.list.forEach(item=>{
        //       resdata.data.MESSAGE.forEach(jtem=>{
        //         if(jtem.F_DJBH==item.flowId){
        //           item.F_GX_STATUS = jtem.F_GX_STATUS
        //           if((new Date().getTime()-jtem.F_TIME )/3600000 < 1){
        //             item.F_TIME = '1'
        //             item.F_Text = '小时内'
        //           }else if((new Date().getTime()-jtem.F_TIME )/3600000 < 24){
        //             item.F_TIME =((new Date().getTime()-jtem.F_TIME )/3600000).toFloor(0)
        //              item.F_Text = '小时'
        //           }else if((new Date().getTime()-jtem.F_TIME )/3600000 >= 24&&(new Date().getTime()-jtem.F_TIME )/3600000< 24*7){
        //             item.F_TIME =((new Date().getTime()-jtem.F_TIME )/3600000/24).toFloor(1)
        //             item.F_Text = '天'
        //           }else{
        //              item.F_TIME =((new Date().getTime()-jtem.F_TIME )/3600000/24).toFloor(0)
        //              item.F_Text = '天'

        //           }

        //             }
        //         })
        //         })

        //      this.listData = JSON.parse (JSON.stringify( res.data.list))||[]
        //       this.listLen = JSON.parse (JSON.stringify( res.data.totalResults)) || 0
        //   })
        //   .catch(() => {
        //     this.isLoading = false
        //   })
        this.listData = res.data.list || []
        this.listLen = res.data.totalResults || 0
      } else {
        this.isLoading = false
        this.listData = res.data.list || []
        // 待办的receiveTime为null时，显示时间用updateTime
        if (this.curTab === 0) {
          this.listData && this.listData.forEach(item => {
            if (!item.receiveTime) {
              item.receiveTime = item.createTime
            }
          })
        }
        this.listLen = res.data.totalResults || 0
      }
    },
    // 获取筛选关键字
    getFilterTags(params) {
      if (this.curTab === 1 || this.curTab === 3) {
        // 已办，通知
        getTags(params)
          .then(res => {
            this.tags = res.data || []
          })
          .catch(e => {
            this.isLoading = false
          })
      } else if (this.curTab === 2) {
        // 发起
        getInitiatorTags(params)
          .then(res => {
            this.tags = res.data || []
          })
          .catch(e => {
            this.isLoading = false
          })
      }
    },
    // 获取发起中未办的数量
    getInitiaorCount() {
      getInitiaorCount().then(res => {
        if (res.code === 0) {
          this.launchCount = res.data
        }
      })
    },
    // 获取通知中未读的数量
    getNoticeCount() {
      getNoticeCount().then(res => {
        if (res.code === 0) {
          this.noticeCount = res.data
          localStorage.setItem('noticeCount', this.noticeCount)
        }
      })
    },
    /**
     * @function {更新页面}
     * @param bool {是否更新过滤器}
     */
    reload(bool) {
      this.getData(bool)
      this.curTab === 3 && this.getNoticeCount()
    },
    // 计算标记的todoIds
    markIds(todoIds) {
      todoIds = JSON.parse(todoIds)
      let curIds = localStorage.getItem('markedIds')
        ? localStorage.getItem('markedIds').split(',')
        : []
      let newIds = curIds.concat(
        todoIds.filter(id => curIds.indexOf(todoId => todoId) === -1)
      )
      this.markedIds = newIds
    },
    // 诸葛参数
    zhugeParmas(item) {
      this.markedSystemNo = item.map(item => item.systemNo)
      this.markedBusinessType = item.map(item => item.businessType)
    },
    // 切换分页
    changePage(val) {
      localStorage.setItem('markedIds', this.markedIds)
      this.form.pageNo = val
      this.getData()
    },
    // 切换页面容量
    changePageSize(val) {
      this.form.pageNo = 1
      this.form.pageSize = val
      this.getData()
    },
    // 筛选待办时间
    changedohalfTime(val) {
      let nowDate = new Date().getTime()
      let day = 1000 * 60 * 60 * 24
      let filterDate = ''
      switch (val) {
        case -1: // 全部
          this.dateVals = []
          filterDate = '全部'
          this.changeTerm()
          break
        case -2: // 其他
          this.dateVals = []
          filterDate = '其他'
          break
        case 1: // 当天
          filterDate = '当天'
          this.dateVals = [this.formatTime(nowDate), this.formatTime(nowDate)]
          this.changeTerm()
          break
        case 2: // 2 - 3天
          filterDate = '2-3天'
          let startDate = this.formatTime(nowDate - day * 2)
          let endDate = this.formatTime(nowDate - day * 1)
          this.dateVals = [startDate, endDate]
          this.changeTerm()
          break
        case 3: // 3天以上
          filterDate = '3天以上'
          this.dateVals = ['', this.formatTime(nowDate - day * val)]
          this.changeTerm()
          break
      }
      window.zhuge.track('根据时间筛选', {
        tab: this.curTab,
        filterDate: filterDate
      })
    },
    // 时间改变
    changeTime(val) {
      if (val === -1) {
        this.dateVals = []
        this.changeTerm()
      } else if (val === -2) {
        this.dateVals = []
      } else {
        const oneDayTime = 3600 * 1000 * 24
        const endTime = new Date().getTime()
        const startTime = endTime - oneDayTime * val
        this.dateVals = [this.formatTime(startTime), this.formatTime(endTime)]
        this.changeTerm()
      }
      let filterDate = ''
      switch (val) {
        case -1:
          filterDate = '全部'
          break
        case -2:
          filterDate = '其他'
          break
        case 3:
          filterDate = '最近3天'
          break
        case 7:
          filterDate = '最近7天'
          break
        case 30:
          filterDate = '最近30天'
          break
      }
      window.zhuge.track('根据时间筛选', {
        tab: this.curTab,
        filterDate: filterDate
      })
    },
    formatTime(time) {
      const dateObj = new Date(time)
      const Y = dateObj.getFullYear()
      const M = dateObj.getMonth() + 1
      const D = dateObj.getDate()
      return `${Y}/${M < 10 ? `0${M}` : M}/${D < 10 ? `0${D}` : D}`
    },
    // 切换条件
    changeTerm(type) {
      if (this.isLoading) return false
      this.zhugeTrack(type)
      const isInput = type === 'search'
      if (isInput) {
        this.isRead = -1
        this.datePicker = -1
        this.dateVals = []

        this.status = -1
      }
      this.form.pageNo = 1
      this.getData(isInput)
      // 时间埋点
      let hasOtherTime = Array.isArray(type)
      if (hasOtherTime) {
        window.zhuge.track('根据时间筛选', {
          tab: this.curTab,
          filterDate: '其他',
          startDate: type && type[0],
          endDate: type && type[1]
        })
      }
      // 我的通知--待办状态埋点
      if (this.curTab === 3) {
        let hasStatus = typeof type === 'number'
        if (hasStatus) {
          let filterStatus = type === 1 ? '已读' : type === 0 ? '未读' : '全部'
          window.zhuge.track('根据状态筛选', {
            tab: this.curTab,
            filterStatus: filterStatus
          })
        }
      }
      // 我的发起--待办状态埋点
      if (this.curTab === 2) {
        let hasStatus = typeof type === 'number'
        if (hasStatus) {
          let filterStatus = type === 1 ? '已完成' : type === 0 ? '未完成' : '全部'
          window.zhuge.track('根据状态筛选', {
            tab: this.curTab,
            filterStatus: filterStatus
          })
        }
      }
      // 待办类型埋点
      let hasType = typeof type === 'string'
      if (hasType) {
        let filterType = ''
        this.tags && this.tags.forEach(item => {
          if (type === item.tagValue) {
            filterType = item.name
          }
        })
        if (!type) {
          filterType = '全部'
        }
        window.zhuge.track('根据类型筛选', {
          tab: this.curTab,
          filterType: filterType
        })
      }
    },
    delData(row) {
      let titleTips = `该待办已超过七天未处理，如果是垃圾待办，可以删除。一旦删除将不可恢复，请谨慎操作！`
      this.$confirm(titleTips, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          delDohalfData(row.todoId).then(res => {
            if (res.code === 0) {
              this.getData(true)
              this.$message.success('删除成功!')
              window.zhuge.track('确定删除待办', {
                systemNo: row.systemNo,
                businessType: row.businessType,
                todoId: row.todoId
              })
            }
          })
        })
        .catch(() => {
        // this.$message.info('取消删除')
          window.zhuge.track('取消删除待办', {
            systemNo: row.systemNo,
            businessType: row.businessType,
            todoId: row.todoId
          })
        })
    },
    /** zhuge 埋点
     * @param type 仅通过自身属性单点式查看事件
     */
    zhugeTrack(type) {
      try {
        if (type === 'search') {
          // 切换页签
          window.zhuge.track('搜索', { tab: this.curTab })
        } else {
          // window.zhuge.track('筛选', { tab: this.curTab })
        }
      } catch (e) {
      }
    }
  },
  created() {
    if (window.location.href.indexOf('process=1') > -1) {
      this.curTab = 2
      if (window.location.href.indexOf('unfinished=1') > -1) {
        this.statusOnce = true
        this.status = 0
      }
    }
    this.getData(true)
    this.getInitiaorCount()
    this.getNoticeCount()
    window.zhuge.track('待办列表PV')
  },

  mounted() {
    // 表格高度自适应
    const _this = this
    // 是否在云图梭中
    this.IS_IN_YTS_PUB = window.jsBridge && window.jsBridge.runEnvyts

    this.tableHeight = window.innerHeight - this.$refs.topbar.offsetHeight - 52
    window.onresize = function () {
      _this.tableHeight =
          window.innerHeight - _this.$refs.topbar.offsetHeight - 52
    }

    window.localStorage.setItem('curTab', 0)
    localStorage.setItem('markedIds', [])
    this.pickerDefault = new Date()
    this.pickerDefault.setMonth(this.pickerDefault.getMonth() - 1)
    // 返回刷前台刷新
    this.listenVisibility()

    // 获取用户信息, 设置诸葛
    getUserInfo().then(res => {
      if (res.code === 0) {
        window.zhuge.identify(res.data)
        localStorage.setItem('TY_USER_ID', res.data)
        window.zhuge.setSuperProperty({ usercode: res.data })
      }
    })
    window.zhuge.setSuperProperty({ handleTime: new Date().toLocaleString() })
    // 监听桌面刷新
    let that = this
    window.jsBridge && window.jsBridge.ipcRenderer.on('webview-window-close-event', function () {
      // 监听到webview关闭
      console.log('监听到webview关闭')
      that.getData(true, false)
    })
  }
}
</script>
<style lang="stylus">
.radio-wrap{
  position:relative;
}
.boldFather {
  .el-radio {
    font-weight: 900
  }
}

.boldTime {
  .el-radio__label {
    font-weight: 900
  }
}

.flexBox {
  display: flex;
  justify-content: flex-end;
}

.blockColor {
  width: 14px;
  height: 14px;
  // background: #92b5ff;
  background: #F0DC5A;
  border-radius: 2px;
  display: inline-block;
  margin-right: 7px;
}

.blockColorY {
  width: 14px;
  height: 14px;
  // background: #ffd9a0;
  background: #FF962F;
  border-radius: 2px;
  display: inline-block;
  margin-right: 7px;
}

.blockColorR {
  margin-right: 7px;
  width: 14px;
  height: 14px;
  // background: #fd97b1;
  background: #FF3B30;
  border-radius: 2px;
  display: inline-block;
}

.flexAlign {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.has-gutter {
  .el-table tr {
    background: #F5F5F5 !important;
  }
}

.el-table {
  color: #323232;
}

.bread::before {
  content: ' ';
  display: inline-block;
  height: 12px;
  position: fixed;
  left: 20px;
  width: 100vw;
  top: 72px;
  z-index: 999;
  margin-top: -24px;
  border-radius: 0 2px 2px 0;
}
// 代办tab中的日期图标提示
.wait-stay-tips{
   margin:0;
   position:absolute;
   right:30px;bottom:-40px;
}
</style>
